import styled from 'styled-components';

export const LoginTitleLeft = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;
export const Wrapper = styled.form`
  padding: ${({ theme }) => theme.spacing.x10};
  overflow: auto;
`;
export const LoginLoginBox = styled.div`
  height: 100%;
`;
export const LoginForget = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.secondary};
`;
export const LoginButton = styled.button`
  margin-top: auto;
`;
